import ValueChain from "../ValueChain";

interface textConfidentialProps {
    label: string;
    textValid: boolean;
    textValue: string;
    textName: string;
    onChange: (e: any) => void;
    isConfidential: boolean;
    confidentialInputName: string;
    display: boolean;
    placeholder?: string;
    editableTitle?: JSX.Element;
    maxCharacters?: number;
}

function TextConfidential({
    label,
    textName,
    textValid,
    textValue,
    onChange,
    isConfidential,
    display,
    confidentialInputName,
    placeholder = "",
    editableTitle,
    maxCharacters = 1500
}: textConfidentialProps) {
    return (
        <div className={display ? "hidden-content" : "visible-content"}>
            <div className="form-group">
                {editableTitle ? (
                    <label className="control-label">{editableTitle}</label>
                ) : (
                    <label className="control-label">{label}</label>
                )}

                <textarea
                    className={textValid ? "form-control" : "form-control is-invalid"}
                    value={textValue}
                    name={textName}
                    onChange={onChange}
                    maxLength={maxCharacters}
                    placeholder={placeholder}
                />
            </div>
            <div className="checkbox-container">
                <div className="checkbox-confidential">Sensitive</div>
                <input
                    name={confidentialInputName}
                    className="checkbox-input form-check-input"
                    checked={isConfidential}
                    type="checkbox"
                    onChange={onChange}
                />
                <div
                    className={
                        textValue.length === maxCharacters
                            ? "char-counter error-text-important"
                            : "char-counter"
                    }
                >
                    {textValue.length}/{maxCharacters}
                </div>
            </div>
        </div>
    );
}

export default TextConfidential;